import { RootState } from "../../store";

export const documentTypesSelector = (state: RootState) => {
    return state.catalog.documentTypes;
};
